import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Row, Col, Form, Button, ListGroup } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { getAppliedFilterData, validateDatefilter, setMultiSelectData } from './helper';
import { FilterFormCheckbox, FilterFormZoneCheckbox, CountryCheckboxForm } from './filterformCheckbox';
import { DATE_FORMAT, DELIVERY_DATE_FORMAT } from '../../../../constants';
// import '../my-portfolio.scss';
import { getSelectedCountryStates } from '../../../../components/Services/action';
import MultiSelect from '../../../../components/ReusableComponents/MultiSelect/index';
// import { COUNTRY } from '../../../constants';
import MyAutosuggest from '../../../../components/ReusableComponents/AutoSuggest/index';
// import { getCountry } from '../../../components/Services/action';
// import * as PortfolioConstants from '../constants';
import Select from 'react-select';
import moment from 'moment';

const productTypes = [ "NORMAL", "QUICK"]
class FilterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: null,
            fromDate: null,
            appliedFilters: [],
            moreFilter: false,
            errorMessage: '',
            selectedCountry: '',
            selectedState: [],
            value: '',
            stateList: [],
            selectedOption : undefined,
            isCountrySelected:false
        }
    }
    componentDidUpdate(prevProps) {
        const { clearAll, filterForm } = this.props
        if (filterForm !== prevProps.filterForm && this.props.filterForm && this.props.filterForm['values']) {
            const tempFilterFormValues = Object.entries(filterForm.values).filter(value => value[1] === true).map(key => key[0]);
            const tempCounterPartyData = tempFilterFormValues.filter(value => this.props.counterPartyData.indexOf(value) !== -1)
            const tempZoneList = tempFilterFormValues.filter(value => this.props.zoneList.map(p => p.name).indexOf(value) !== -1)
            const tempRiskLevel = tempFilterFormValues.filter(value => this.props.riskLevel.indexOf(value) !== -1);
            const tempReportType = tempFilterFormValues.filter(value => this.props.reportType.indexOf(value) !== -1);
            const tempRiskTrend = tempFilterFormValues.filter(value => this.props.riskTrend.indexOf(value) !== -1);
            const tempCaseStatus = tempFilterFormValues.filter(value => this.props.caseStatus.indexOf(value) !== -1);
            const tempLegalConstitution = tempFilterFormValues.filter(value => this.props.legalConstitution.indexOf(value) !== -1);
            const tempBusinessSegment = tempFilterFormValues.filter(value => this.props.businessSegment.indexOf(value) !== -1);
            const tempCaseType = tempFilterFormValues.filter(value => this.props.caseType.indexOf(value) !== -1);
            const tempProductTypes = tempFilterFormValues.filter(value => productTypes.indexOf(value)!== -1);
           
            this.setState({
                appliedFilters: getAppliedFilterData(tempCounterPartyData, tempZoneList, tempRiskLevel, tempReportType, tempRiskTrend, tempLegalConstitution, tempBusinessSegment, tempCaseStatus, tempCaseType, tempProductTypes)
            });
        }
        if (clearAll !== prevProps.clearAll) {
            this.resetPortfolioFilters()
        } else if (this.props.toDate !== prevProps.toDate) {
            this.setState({
                toDate: this.props.toDate,
                fromDate: this.props.fromDate
            })
        } else if (this.props.fromDate !== prevProps.fromDate) {
            this.setState({
                toDate: this.props.toDate,
                fromDate: this.props.fromDate
            })
        }
        if (this.props.selectedCountry !== prevProps.selectedCountry) {
            this.props.selectedCountry.length ? this.setState({
                selectedCountry: this.props.selectedCountry
            }) : this.setState({
                selectedCountry: ''
            });
            if (this.props.selectedCountry && this.props.selectedCountry.length > 0) {
                this.props.getStates(this.props.selectedCountry);
            }
        }
        if (this.props.selectedState !== prevProps.selectedState) {
            this.setState({
                selectedState: this.props.selectedState
            })
        }
        if (this.props.stateList !== prevProps.stateList) {
            this.setState({
                stateList: setMultiSelectData(this.props.stateList)
            })
        }else if(this.state.isCountrySelected && this.state.stateList && this.state.stateList.length==0 && prevProps.stateList && prevProps.stateList.length){
            this.setState({
                stateList: setMultiSelectData(this.props.stateList)
            })
        }
    }
    applyPortfolioFilters = (e) => {
        e.preventDefault();
        const validateDate = validateDatefilter(this.state.toDate, this.state.fromDate);
        if (validateDate) {
            this.setState({
                errorMessage: '',
            })
            let selectedCountry = [];
            if(typeof this.state.selectedCountry === 'object' && this.state.selectedCountry !== null && !Array.isArray(this.state.selectedCountry)){
                selectedCountry = (this.state.selectedCountry.length || this.state.selectedCountry.value) ?  this.state.selectedCountry.value : [];
            }else if(Array.isArray(this.state.selectedCountry)){
                selectedCountry = this.state.selectedCountry.length ?  this.state.selectedCountry[0] : [];
            }else{
                selectedCountry = this.state.selectedCountry.length  ?  this.state.selectedCountry : [];
            }            
            this.props.filterFormCallback(this.state.appliedFilters, this.state.toDate, this.state.fromDate, selectedCountry, this.state.selectedState, true)
        } else {
            this.setState({
                errorMessage: 'Both date fields are mandatory'
            })
        }

    }
    hidePortfolioFilters = () => {
        this.props.hidePortfolioFiltersCallback()
    }
    resetPortfolioFilters = () => {
        this.props.filterFormCallback()
        this.props.reset();
        this.setState({
            toDate: null,
            fromDate: null,
            selectedCountry: ''
        })
    }
    handleFromDateChange = (date) => {
        this.setState({ fromDate: date })
    }
    handleToDateChange = (date) => {
        this.setState({ toDate: date })
    }
    showMoreFilters = () => {
        this.setState({ moreFilter: !this.state.moreFilter })
    }
    searchCallback = (selected, type) => {
        if (type === 'countrySearch') {
            this.setState({
                selectedCountry: selected,
                isCountrySelected:true
            });
            this.props.getStates(selected.value);
        } else {
            this.setState({
                selectedState: selected
            })
        }

    }
    selectedEntityCallback = (data) => {
        this.setState({
            selectedState: data
        })
    }
    render() {
        const { value } = this.state
        let country = false;
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        };
        // if (this.state.selectedCountry && Object.keys(this.state.selectedCountry).length > 0) {
        //     if (this.state.selectedCountry.value === 'India') {
        //         country = true
        //     } else {
        //         country = false
        //     }
        // }
        return (
            <Form>
                <Row noGutters className="mb-4">
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Counterparty Type<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.counterPartyData.map(counterPartyCheckboxData => {
                                return (
                                    <FilterFormCheckbox corporateColor={this.props.corporateColor} key={counterPartyCheckboxData} checkboxData={counterPartyCheckboxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                    { !this.props.withoutRiskScore && 
                    <Col sm="4" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Risk Level<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.riskLevel.map(riskLevelCheckboxData => {
                                return (
                                    <FilterFormCheckbox corporateColor={this.props.corporateColor} key={riskLevelCheckboxData} checkboxData={riskLevelCheckboxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                    }
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between mb-1">Country<i className="icon-minus d-sm-none"></i></span>
                        <MyAutosuggest
                            id='countrySearch'
                            placeholder="Search Country"
                            onChange={this.handleCountryAutocomplete}
                            searchCallback={this.searchCallback}
                            selectedValueCountry={this.state.selectedCountry}
                            inputProps={inputProps}
                            searchType="countrySearch" />
                    </Col>
                    {
                        (country) ? <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between mb-1">Region<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.zoneList.map(zoneListCheckboxData => {
                                    return (
                                        <FilterFormZoneCheckbox corporateColor={this.props.corporateColor} key={zoneListCheckboxData.id} zoneListCheckboxData={zoneListCheckboxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col> : <Col sm="5" className="filter-category p-3 py-sm-0">
                                <span className="filter-popover-header-item d-flex justify-content-between mb-1">State<i className="icon-minus d-sm-none"></i></span>
                                {/* <MyAutosuggest
                                    id='stateSearch'
                                    placeholder="Search State"
                                    onChange={this.handleCountryAutocomplete}
                                    searchCallback={this.searchCallback}
                                    inputProps={inputProps}
                                    selectedValueState={this.state.selectedState}
                                    countryValue={(this.state.selectedCountry) ? this.state.selectedCountry.id : ''}
                                    searchType="stateSearch" /> */}
                                <MultiSelect
                                    data={this.state.stateList}
                                    selected={this.selectedEntityCallback}
                                    selectedValue={this.state.selectedState} />
                            </Col>
                    }
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Class of Company<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.legalConstitution.map(legalConstitutionCheckBoxData => {
                                return (
                                    <FilterFormCheckbox corporateColor={this.props.corporateColor} key={legalConstitutionCheckBoxData} checkboxData={legalConstitutionCheckBoxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                </Row>
                {this.state.moreFilter && (
                    <Row noGutters className="mb-3">
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Report Type<i className="icon-plus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.reportType.map(reportTypeCheckboxData => {
                                    return (
                                        <FilterFormCheckbox corporateColor={this.props.corporateColor} key={reportTypeCheckboxData} checkboxData={reportTypeCheckboxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Business Segment<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.businessSegment.map(businessSegmentCheckboxData => {
                                    return (
                                        <FilterFormCheckbox corporateColor={this.props.corporateColor} key={businessSegmentCheckboxData} checkboxData={businessSegmentCheckboxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        <Col sm="4" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Case Status<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.caseStatus.map(caseStatusCheckBoxData => {
                                    return (
                                        <FilterFormCheckbox corporateColor={this.props.corporateColor} key={caseStatusCheckBoxData} checkboxData={caseStatusCheckBoxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        {/*<Col sm="3" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Risk Trend<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.riskTrend.map(riskTrendCheckBoxData => {
                                    return (
                                        <FilterFormCheckbox corporateColor={this.props.corporateColor} key={riskTrendCheckBoxData} checkboxData={riskTrendCheckBoxData} />
                                    )
                                })}
                            </ListGroup>
                            </Col>*/}
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                                <span className="filter-popover-header-item d-flex justify-content-between">
                                Delivery Date Range
                                <i className="icon-minus d-sm-none"></i>
                                </span>
                            <div className="filter-options">
                            <div name="fromDate" className="d-flex justify-content-between filter-datepicker">
                                <span className="filter-datepicker-label">From</span>
                            <DatePicker 
                                className="mb-2 ml-1" 
                                selected={this.state.fromDate ? moment(this.state.fromDate).toDate() : null} 
                                placeholderText={DATE_FORMAT} 
                                onChange={this.handleFromDateChange} 
                                dateFormat={DELIVERY_DATE_FORMAT} 
                                maxDate={moment().toDate()} />
                            </div>
                            <div className="d-flex justify-content-between filter-datepicker">
                                <span className="filter-datepicker-label">To</span>
                            <DatePicker 
                                className="ml-1" 
                                selected={this.state.toDate ? moment(this.state.toDate).toDate() : null} 
                                placeholderText={DATE_FORMAT} 
                                onChange={this.handleToDateChange} 
                                dateFormat={DELIVERY_DATE_FORMAT} 
                                maxDate={moment().toDate()} />
                            </div>
                            </div>
                                <span className="text-danger">{this.state.errorMessage}</span>
                        </Col>

                    <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Case Type<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.caseType.map(caseTypeCheckBoxData => {
                                    return (
                                        <FilterFormCheckbox corporateColor={this.props.corporateColor} key={caseTypeCheckBoxData} checkboxData={caseTypeCheckBoxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Product Type<i className="icon-plus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                            {productTypes.map(productType => {
                                return (
                                    <FilterFormCheckbox corporateColor={this.props.corporateColor} key={productType} checkboxData={productType} />
                                )
                            })}
                        </ListGroup>
                        </Col>
                    </Row>
                    )}
                <Row>
                    <Col className="d-flex flex-column flex-sm-row justify-content-sm-between">
                        <div className="mb-3 mb-sm-0 d-flex justify-content-between">
                            <Button className="px-3 advance-filter-button" style={{ '--primaryColor': this.props.corporateColor }} outline onClick={this.showMoreFilters}>{this.state.moreFilter ? 'Hide Filters' : 'Advance Filters'}</Button>
                            {/*<Button className="px-3 ml-2" outline color="primary" onClick={this.hidePortfolioFilters}>Hide Filters</Button>*/}
                            <Button className="px-3 ml-2 advance-filter-button" outline style={{ '--primaryColor': this.props.corporateColor }} onClick={this.resetPortfolioFilters}>Reset</Button>
                        </div>

                        <Button className="apply-button" style={{ '--primaryColor': this.props.corporateColor }} onClick={this.applyPortfolioFilters}>Apply</Button>
                    </Col>
                </Row>
            </Form >
        )
    }
}
FilterForm = reduxForm({
    form: 'filterform',
    enableReinitialize: true
})(FilterForm)

const mapStateToProps = (state, ownProps) => ({
    filterForm: state.form.filterform,
    filterformData: state.form.filterform,
    stateList: state.commonReducer.stateListSuccess,
    stateListFailure: state.commonReducer.stateListFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    // getCountry: (search) => { dispatch(getCountry(search)) }
    getStates: (data) => { dispatch(getSelectedCountryStates(data)) }
});
export default FilterForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterForm)
